export enum Estado {
    esboco = 'ESBOÇO',
    submetido = 'SUBMETIDO',
}
